export const LOG_OUT = "LOG_OUT";
export const  LOG_OUT_FETCHING = "LOG_OUT_FETCHING";
export const  LOG_OUT_SUCCESS = "LOG_OUT_SUCCESS";
export const  LOG_OUT_FAILED = "LOG_OUT_FAILED";
